import dayjs from "dayjs";
import { Stack, Text, Group } from "@mantine/core";
import { StainMarkerVerificationSummary } from "../../../services/admin/stains.service";

interface Props {
  summary: StainMarkerVerificationSummary;
}

export function StainMarkerVerificationTooltip({ summary }: Props) {
  return (
    <Stack gap={4} p={4}>
      <Group gap={8}>
        <Text size="xs" fw={700}>
          Status:
        </Text>
        <Text size="xs">{summary.status.toUpperCase()}</Text>
      </Group>
      {summary.markerValueSent && (
        <Group gap={8}>
          <Text size="xs" fw={700}>
            Marker Sent:
          </Text>
          <Text size="xs">{summary.markerValueSent}</Text>
        </Group>
      )}
      {summary.testedAt && (
        <Group gap={8}>
          <Text size="xs" fw={700}>
            Tested At:
          </Text>
          <Text size="xs">
            {dayjs(summary.testedAt).format("YYYY-MM-DD HH:mm")}
          </Text>
        </Group>
      )}
      {summary.rejectionReason && (
        <Group gap={8}>
          <Text size="xs" fw={700} c="red">
            Rejection:
          </Text>
          <Text size="xs" c="red">
            {summary.rejectionReason}
          </Text>
        </Group>
      )}
      {summary.errorMessage && (
        <Group gap={8}>
          <Text size="xs" fw={700} c="red">
            Error:
          </Text>
          <Text size="xs" c="red">
            {summary.errorMessage}
          </Text>
        </Group>
      )}
    </Stack>
  );
}
